import { createFileRoute } from "@tanstack/react-router";
import { ComingSoon } from "@client/components/coming-soon";
import { useTranslation } from "react-i18next";

function StorageCleanupPage() {
  const { t } = useTranslation("systemSettings");
  return (
    <ComingSoon message={t("comingSoon.storageCleanup")} />
  );
}

export const Route = createFileRoute("/_app/settings/storage-cleanup")({
  component: StorageCleanupPage,
});
